import Vue from 'vue';

const miniProgram = {
  actions: {
    // eslint-disable-next-line
        showMiniproModal ({state}, payload) {
      Vue.$sendLog({
        tp: `点击${payload.name}小程序`, desc: `${payload.page}点击${payload.name}小程序`, category: `${payload.page}`, optLabel: `${payload.page}点击${payload.name}小程序`,
      });
      Vue.$RaiseMessage.alert(payload.modalImg, '', {
        closeCallback: () => {
          Vue.$sendLog({
            tp: `${payload.name}小程序弹窗关闭`, desc: `${payload.page}${payload.name}小程序弹窗关闭`, category: `${payload.page}`, optLabel: `${payload.name}小程序弹窗关闭`,
          });
        },
      });
    },
  },
};
export default miniProgram;
